import { render } from "./CaptchaComponent.vue?vue&type=template&id=253f4d5c&scoped=true"
import script from "./CaptchaComponent.vue?vue&type=script&lang=js"
export * from "./CaptchaComponent.vue?vue&type=script&lang=js"

import "./CaptchaComponent.vue?vue&type=style&index=0&id=253f4d5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253f4d5c"]])

export default __exports__